import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TaskIcon from "@mui/icons-material/Task";
import { Badge, Box, Divider, Fab, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { t } from "i18next";
import React, { useState } from "react";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { TodoTaskTable } from "./TodoTaskTable";

const SIDEBAR_WIDTH = "90%";

const StyledDrawer = styled(Box)(({ theme }) => ({
    position: "fixed",
    top: 0,
    right: 0,
    width: SIDEBAR_WIDTH,
    height: "100vh",
    backgroundColor: theme.palette.background.paper,
    zIndex: theme.zIndex.drawer,
    boxShadow: theme.shadows[16],
    transform: "translateX(100%)",
    transition: "transform 0.3s ease-in-out",
    "&.open": {
        transform: "translateX(0)",
    },
}));

const FloatingToggleButton = styled(Fab)(({ theme }) => ({
    position: "fixed",
    top: theme.spacing(10),
    right: theme.spacing(2),
    zIndex: theme.zIndex.speedDial,
}));

export function TodoTasksSidebar({ userId }) {
    const [isOpen, setIsOpen] = useState(false);
    const { openDialog } = useDialogBetter();

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <FloatingToggleButton
                color="primary"
                aria-label="toggle todo tasks"
                onClick={handleToggle}
                size="medium"
            >
                <Badge>
                    <TaskIcon />
                </Badge>
            </FloatingToggleButton>
            {/* Sidebar */}
            <StyledDrawer className={isOpen ? "open" : ""}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 2,
                        backgroundColor: "primary.main",
                        color: "primary.contrastText",
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {t("tasks.todoSidebar.title")}
                    </Typography>
                    <IconButton onClick={handleToggle} sx={{ color: "inherit" }} size="small">
                        <ChevronRightIcon />
                    </IconButton>
                </Box>

                <Divider />

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        mt: 5,
                        ml: 5,
                        mr: 2,
                    }}
                >
                    <TodoTaskTable userId={userId} />
                </Box>
            </StyledDrawer>
        </>
    );
}
